export const skipTimeGap = 1;
